import type { FC } from 'react'

import { Avatar } from '@liveHelper/components/shared/Avatar'
import { TripleDotLoader } from '@liveHelper/components/shared/TripleDotLoader'
import { AGENT_AGORA_TRACK_PLAYER_ID } from '@oneToOne/shared/components/chat/constants'
import type { IAgoraRTCRemoteUser } from 'agora-rtc-sdk-ng'

import {
  AgentAgoraTrackPlayer,
  TripleDotLoaderWrapper,
} from './RingingTrackPlayer.styles'

interface RingingTrackPlayerProps {
  remoteUser: IAgoraRTCRemoteUser | undefined
}
/**
 * Shared Component for rendering the agent's video track.
 */
export const RingingTrackPlayer: FC<RingingTrackPlayerProps> = ({
  remoteUser,
}) => {
  return (
    <>
      {/* Do not play agent audio in ringing state. */}
      {!remoteUser ? (
        <TripleDotLoaderWrapper>
          <TripleDotLoader />
        </TripleDotLoaderWrapper>
      ) : !remoteUser.videoTrack ? (
        <Avatar />
      ) : (
        <AgentAgoraTrackPlayer
          id={AGENT_AGORA_TRACK_PLAYER_ID}
          videoTrack={remoteUser.videoTrack}
        />
      )}
    </>
  )
}
